export default "assets/images/home-174bc085.jpg";